import { Element } from './types'
import { eventSystem } from 'modules-core/eventSystem'
import { filterByElementId } from './utility'

// Register events.
eventSystem.add('setElementVolume')
eventSystem.add('setElementAdjustmentVolume')

interface Args {
	elementMap: Element.MutableMap
}
export const createElementVolumeSystem = ({ elementMap }: Args) => {

	const elementVolumeMap = new Map<number, number>()
	const elementAdjustmentVolumeMap = new Map<number, number>()

	const system = {
		elementVolumeMap,
		elementAdjustmentVolumeMap,
		setElementIdVolume: (elementId: number, value: number) => {
			if (elementVolumeMap.get(elementId) === value)
				return
			elementVolumeMap.set(elementId, value)
			filterByElementId(elementMap, elementId)
				.forEach(([, element]) => element.setVolume(value))
			eventSystem.dispatch('setElementVolume', {
				elementId,
				volume: value,
			})
		},
		setElementIdAdjustmentVolume: (elementId: number, value: number) => {
			if (elementAdjustmentVolumeMap.get(elementId) === value)
				return
			elementAdjustmentVolumeMap.set(elementId, value)
			filterByElementId(elementMap, elementId)
				.forEach(([, element]) => element.setAdjustmentVolume(value))
			eventSystem.dispatch('setElementAdjustmentVolume', {
				elementId,
				volume: value,
			})
		}
	}
	return system
}

export type ElementVolumeSystem = ReturnType<typeof createElementVolumeSystem>
